import { motion } from 'framer-motion';
import styled from 'styled-components/macro';

const AnimationWrapper = styled(motion.div)`
whileInView: { y: [100, 50, 0], opacity: [0, 0, 1] };
		transition: { duration: 0.5 };`;

export default AnimationWrapper;
